import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Paper,
  CircularProgress,
} from '@mui/material';
import { AutoAwesome as AIIcon } from '@mui/icons-material';
import type { EmailAiReplyDialogProps } from './types';

const EmailAiReplyDialog: React.FC<EmailAiReplyDialogProps> = ({
  open,
  suggestions,
  loading,
  onClose,
  onUseSuggestion,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <AIIcon />
          KI-Antwortvorschläge
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box display="flex" flexDirection="column" alignItems="center" py={4}>
            <CircularProgress size={40} />
            <Typography color="textSecondary" sx={{ mt: 2 }}>
              Generiere Antwortvorschläge...
            </Typography>
          </Box>
        ) : suggestions.length === 0 ? (
          <Typography color="textSecondary" align="center" py={4}>
            Keine Antwortvorschläge verfügbar
          </Typography>
        ) : (
          <Box display="flex" flexDirection="column" gap={2}>
            {suggestions.map((suggestion, index) => (
              <Paper
                key={index}
                variant="outlined"
                sx={{
                  p: 2,
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: 'action.hover',
                    borderColor: 'primary.main',
                  },
                }}
                onClick={() => onUseSuggestion(suggestion)}
              >
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                  <Typography variant="subtitle2" color="primary">
                    Vorschlag {index + 1}
                    {suggestion.tonalitaet && ` (${suggestion.tonalitaet})`}
                  </Typography>
                  <Button size="small" variant="outlined">
                    Übernehmen
                  </Button>
                </Box>
                <Typography
                  variant="body2"
                  sx={{
                    whiteSpace: 'pre-wrap',
                    lineHeight: 1.6,
                  }}
                >
                  {suggestion.text}
                </Typography>
              </Paper>
            ))}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Schließen</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmailAiReplyDialog;
